import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import CaseStudiesSection from "./CaseStudiesSection";
import EventsSection from "./EventsSection";
import VideoGallerySection from "./VideoGallerySection";
import React from "react";
import PostsSection from "./PostsSection";

export default function HomeNinjaPage() {
  return (
    <>
      <Helmet>
        <title>Expert Advice for Achieving Goals - Ninja Shop</title>
        <meta
          name="description"
          content="Reach your goals faster with Ninja Shop's expert advice. Explore trending questions, financial insights, and case studies to enhance your skills."
        />
        <script src="//uae.fw-cdn.com/40167787/102664.js" chat="true"></script>
      </Helmet>
      <div className="flex w-full flex-col gap-3.5 overflow-x-scroll bg-gray-50">
        <div>
          <div className="rounded-bl-[20px] rounded-br-[20px] bg-gray-900_02 py-[34px] sm:py-4">
            <Header />
          </div>
        </div>
        <div className="flex flex-col gap-3.5 mb-5">
          {/* video gallery section */}
          <VideoGallerySection />

          {/* posts section */}
          <PostsSection />

          {/* case studies section */}
          <CaseStudiesSection />

          {/* events section */}
          <EventsSection />
        </div>
      </div>
    </>
  );
}
